import { render, staticRenderFns } from "./ApplicationHelpPopUp.vue?vue&type=template&id=2a348799&scoped=true&"
import script from "./ApplicationHelpPopUp.vue?vue&type=script&lang=js&"
export * from "./ApplicationHelpPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationHelpPopUp.vue?vue&type=style&index=0&id=2a348799&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a348799",
  null
  
)

export default component.exports